// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I2sn","largestCol":"styles_largestCol__3_CU6","smallestCol":"styles_smallestCol__1MBLd"};